import React from 'react';
import { useUser } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';

const Header = () => {
    const { user, isAuthenticated, logout } = useUser();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/auth'); // Перенаправляем на страницу входа после выхода
    };

    return (
        <header className="fixed top-0 left-64 right-0 h-16 bg-gray-800 bg-opacity-80 backdrop-filter backdrop-blur-sm shadow-md z-10 flex items-center justify-end px-6">
            {isAuthenticated && user ? (
                <div className="flex items-center gap-4">
                    <span className="text-sm text-gray-300">
                        Добро пожаловать, <span className="font-medium text-white">{user.first_name || user.username || 'User'}</span>!
                    </span>
                    <button 
                        onClick={handleLogout}
                        className="flex items-center gap-1 py-1.5 px-3 bg-red-600 hover:bg-red-700 text-white text-xs font-semibold rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75 transition ease-in-out duration-150"
                    >
                        <ArrowRightOnRectangleIcon className="h-4 w-4" />
                        <span>Выйти</span>
                    </button>
                </div>
            ) : (
                // Можно добавить что-то для неаутентифицированных пользователей, если нужно
                <div></div> 
            )}
        </header>
    );
};

export default Header; 